import { Column, Index } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';

/**
 * PD-16874 — a Google business one rep dismissed from the Sales Helper's
 * prospect search as "not a fit".
 *
 * Per rep (owner decision 2026-10-07): a dismissal hides the business only
 * from THAT rep's searches; every other rep still sees it, because what is a
 * poor fit for one territory or book can be right for another. One row per
 * (rep, Google place); "undo that" soft-removes the row, and dismissing the
 * same business again recovers it, so the audit trail stays on one record.
 *
 * Separate from the Lead Finder's company-wide `lead_finder_dismissal`, which
 * is unchanged. New table, created by the database sync; SM1 never names it.
 */
@Index('uq_prospect_dismissal_user_place', ['fkUserId', 'googlePlaceId'], { unique: true })
@Entity('prospect_dismissal')
export class ProspectDismissalEntity extends BaseEntity {
	/** The rep who dismissed it: the tenant (instance) user, user._id. */
	@Column('int', { name: 'fk_user__id', unsigned: true })
	public fkUserId!: number;

	/** Google's place id for the business (the same id `client.googlePlaceId` holds). */
	@Column('varchar', { name: 'googlePlaceId', length: 255 })
	public googlePlaceId!: string;

	/** Why it is not a fit, in the rep's words, when they gave one. */
	@Column('varchar', { name: 'reason', length: 255, nullable: true })
	public reason!: string | null;
}
